<template>
    <div class="flex items-start flex-col leading-none w-full">
        <label class="mr-auto cursor-pointer" :for="id">{{ label }}</label>
        
        <span v-if="error" class="text-red-500 border-l-2 border-red-500 pl-2 mt-2">{{ error }}</span>

        <div class="inline-block relative w-full mt-3" v-if="type == 'select'">
            <select v-model="valueInput" class="block appearance-none w-full bg-white border border-gray-500 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow-sm leading-tight focus:outline-none focus:shadow-outline">
                <option value="null" selected disabled>Selectionnez</option>
                <option v-for="(option, index) in options" :value="option.value ? option.value: option.label" :key="index">{{ option.label }}</option>
            </select>
            
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        </div>

        <textarea
            v-else-if="type == 'textarea'"
            :id="id"
            class="w-full border px-3 py-2 mt-3 rounded outline-none appearance-none focus:shadow-outline shadow-sm"
            :class="{'border-2 border-red-500': error, 'border border-gray-500' : !error}"
            v-bind="$attrs"
            v-model="valueInput"
        ></textarea>

        <input
            v-else-if="type == 'number'"
            type="number"
            :id="id"
            :placeholder="label"
            v-bind="$attrs"
            class="w-full px-3 py-2 mt-3 rounded outline-none appearance-none focus:shadow-outline shadow-sm"
            :class="{'border-2 border-red-500': error, 'border border-gray-500' : !error}"
            step="0.01"
            v-model.number="valueInput"
        />

        <input
            v-else
            :type="type"
            :id="id"
            :placeholder="label"
            v-bind="$attrs"
            class="w-full px-3 py-2 mt-3 rounded outline-none appearance-none focus:shadow-outline shadow-sm"
            :class="{'border-2 border-red-500': error, 'border border-gray-500' : !error}"
            v-model="valueInput"
        />

        <div class="text-gray-500 mt-3 leading-relaxed text-left" v-if="hint">
            <svg fill="none" class="h-5 inline" style="margin-top: -3px" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor"><path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <span class="ml-1">{{ hint }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hint: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            required: true,
            default: null
        },
        type: {
            type: String,
            default: 'text'
        },
        error: {
            type: String,
            default: null
        },
        value: {
            default: null
        }
    },
    inheritAttrs: false,
    data: () => {
        return {
            id: 'uid_' + Math.random().toString(36).substr(2, 9),
            valueInput: null
        }
    },
    mounted: function () {     
        this.$nextTick(function () {   
            this.valueInput = this.value;
        });
    },
    watch: {
        valueInput: function(value) {
            this.$emit('input', value);
        }
    }
}
</script>